import type { IOdd } from "~src/interfaces";
import { decodeId } from "~src/helpers/HashIdHelper";

export const parseOddMatchDataArray = (oddDataString: string) => {
  if (!oddDataString || oddDataString.length <= 0) {
    return [];
  }

  const matchOddDataArray = oddDataString.split("!");
  const matchesOdd = matchOddDataArray
    .filter((match) => match)
    .map((match) => {
      const [theSport, ISports, oddAsian, oddEuro, oddOverUnder] =
        match.split("^");
      const [asian_hdp, asian_hdp_home, asian_hdp_away, asian_close] =
        oddAsian.split(":");
      const [european_home, european_draw, european_away, european_close] =
        oddEuro.split(":");
      const [over_under_hdp, over, under, over_under_close] =
        oddOverUnder.split(":");

      return {
        id: decodeId(theSport),
        encode_is_id: ISports,
        asian_hdp: asian_hdp,
        asian_hdp_home: asian_hdp_home,
        asian_hdp_away: asian_hdp_away,
        asian_close: asian_close,
        european_home: european_home,
        european_draw: european_draw,
        european_away: european_away,
        european_close: european_close,
        over_under_hdp: over_under_hdp,
        over: over,
        under: under,
        over_under_close: over_under_close,
      };
    });

  return matchesOdd;
};


export const getOddValue = (odd: IOdd | undefined, oddOld: IOdd | undefined, key: string) => {
  let type = "normal";
  if (!odd || !odd[key]) {
    return {
      type,
      value: "",
    };
  }

  if (oddOld && oddOld[key]) {
    if (oddOld[key] > odd[key]) {
      type = "down";
    } else if (oddOld[key] < odd[key]) {
      type = "up";
    }
  }

  return {
    type,
    value: odd[key],
  };
};

export const getOddData = (odd: IOdd | undefined, oddOld: IOdd | undefined) => {
  const data = {} as {[key: string]: any;}
  for (const key of [
    "asian_hdp",
    "asian_hdp_home",
    "asian_hdp_away",
    "asian_close",
    "european_home",
    "european_draw",
    "european_away",
    "european_close",
    "over_under_hdp",
    "over",
    "under",
    "over_under_close",
  ] as Array<string>) {
    data[key] = getOddValue(odd, oddOld, key);
  }

  return data;
};
